import React, { useState } from 'react';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel, IonCheckbox, IonButton, IonFooter } from '@ionic/react';
import { _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface CopyDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (selectedOptions: string[]) => void;
}

const CopyDialog: React.FC<CopyDialogProps> = ({ isOpen, onClose, onConfirm }) => {
    const [options, setOptions] = useState<string[]>(["all"]);
    const { lang } = useGlobalStore();
    
    const handleOptionChange = (option: string) => {
        let updatedOptions: string[] = [];
        if (option === 'all') {
            updatedOptions = ['all'];
        } else {
            updatedOptions = options.includes('all') ? [option] : [...options, option];
        }
        setOptions(updatedOptions);
    };

    

    const handleConfirm = () => {
        onConfirm(options);
        onClose();
    };

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{_dict.whatDoYouWantToCopy[lang]}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonItem>
                        <IonLabel>{_dict.everything[lang]}</IonLabel>
                        <IonCheckbox checked={options.includes('all')} onIonChange={() => handleOptionChange('all')} />
                    </IonItem>
                    <IonItem>
                        <IonLabel>{_dict.colorCapital[lang]}</IonLabel>
                        <IonCheckbox checked={options.includes('color')} onIonChange={() => handleOptionChange('color')} />
                    </IonItem>
                    <IonItem>
                        <IonLabel>{_dict.image[lang]}</IonLabel>
                        <IonCheckbox checked={options.includes('image')} onIonChange={() => handleOptionChange('image')} />
                    </IonItem>
                    
                </IonList>
                
                
                
            </IonContent>
            <IonFooter>
                
                <IonButton color="dark" expand="full" onClick={handleConfirm}>
                    {_dict.confirm[lang]}
                </IonButton>
                <IonButton color="danger" expand="full" onClick={onClose}>
                    {_dict.undo[lang]}
                </IonButton>
            </IonFooter>
        </IonModal>
    );
};

export default CopyDialog;